import {Conversation} from '@stripe-internal/conversations-client';
import {EmailForm} from '../../components/Forms/Email';

type Props = {
  conversation: Conversation;
  onCancel: () => void;
};

export const EmailModal = ({conversation, onCancel}: Props) => {
  return <EmailForm conversation={conversation} onCancel={onCancel} />;
};
